<div class="px-5 min-h-screen flex justify-content-center align-items-center bg-cover bg-center">
    <div class="relative text-center flex flex-column justify-content-between">
        <div class="text-900 font-bold text-red-400 text-8xl mb-4">
            {{ 'cookies-consent.error-page-title' | translate }}
        </div>
        <p class="line-height-3 mt-0 mb-5 text-700 text-xl font-medium" [ngStyle]="{'white-space': 'pre-line'}">
            {{ 'cookies-consent.error-page-message' | translate }}
            <a target="_blank" class="cursor-pointer text-primary" (click)="downloadDocument()">
                {{ 'cookies-consent.cookies-link' | translate }}.
            </a>
        </p>



        <div class="flex justify-content-center flex-column md:flex-row gap-1 ">
            <p-button label="{{ 'cookies-consent.error-page-accept' | translate }}" icon="pi pi-check"
                styleClass=" p-button-outlined font-medium w-full md:w-auto" (onClick)="acceptCookies()">
            </p-button>


            <p-button label="{{ 'cookies-consent.error-page-deny' | translate }}" icon="pi pi-times"
                styleClass="  p-button-primary font-medium w-full md:w-auto" (onClick)="clearCookiesAndLogout()">
            </p-button>


        </div>
    </div>
</div>